import { useEffect } from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FaTruck, FaUndo, FaCreditCard, FaShieldAlt, FaEnvelope, FaQuestionCircle, FaRuler, FaBox } from 'react-icons/fa';
import StayTop from '../components/StayTop';
import PayLaterMessage from '../components/PayLaterMessage';

const HelpScreen = () => {
    const { hash } = useLocation();

    // Deep links like /help#pay-later — wait for the scroll-to-top effects to run first
    useEffect(() => {
        if (!hash) return undefined;
        const t = setTimeout(() => {
            document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
        return () => clearTimeout(t);
    }, [hash]);

    return (
        <>
            <style>{`
                .help-category-card {
                    background: white;
                    border-radius: 15px;
                    padding: 2rem;
                    margin-bottom: 2rem;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.08);
                    transition: all 0.3s ease;
                    border: 2px solid #f8f9fa;
                }

                .help-category-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 25px rgba(0,0,0,0.12);
                    border-color: #FD7014;
                }

                .help-icon {
                    font-size: 3rem;
                    color: #FD7014;
                    margin-bottom: 1rem;
                }

                .help-category-title {
                    font-size: 1.5rem;
                    font-weight: 700;
                    color: #3E6D9C;
                    margin-bottom: 1rem;
                }

                .help-category-description {
                    color: #666;
                    line-height: 1.6;
                }

                .accordion-button {
                    background-color: #f8f9fa !important;
                    color: #3E6D9C !important;
                    font-weight: 600;
                }

                .accordion-button:not(.collapsed) {
                    background-color: #3E6D9C !important;
                    color: white !important;
                }

                .accordion-button:focus {
                    box-shadow: 0 0 0 0.2rem rgba(253, 112, 20, 0.25);
                }

                .contact-info-box {
                    background: #f8f9fa;
                    border-left: 4px solid #FD7014;
                    padding: 1.5rem;
                    border-radius: 8px;
                    margin-bottom: 1.5rem;
                }

                .contact-info-box h5 {
                    color: #3E6D9C;
                    margin-bottom: 0.5rem;
                }

                .size-chart-table {
                    width: 100%;
                    margin-top: 1rem;
                }

                .size-chart-table th {
                    background-color: #3E6D9C;
                    color: white;
                    padding: 0.75rem;
                    text-align: center;
                }

                .size-chart-table td {
                    padding: 0.75rem;
                    text-align: center;
                    border: 1px solid #dee2e6;
                }

                .size-chart-table tr:nth-child(even) {
                    background-color: #f8f9fa;
                }

                .paylater-section { scroll-margin-top: 110px; }

                .paylater-card {
                    background: white;
                    border-radius: 15px;
                    padding: 1.75rem;
                    height: 100%;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.08);
                    border: 2px solid #f8f9fa;
                }

                .paylater-badge {
                    display: inline-block;
                    font-weight: 800;
                    font-size: 1.15rem;
                    padding: 0.35rem 0.9rem;
                    border-radius: 8px;
                    margin-bottom: 1rem;
                }
                .paylater-badge--klarna { background: #FFB3C7; color: #0B051D; }
                .paylater-badge--clearpay { background: #B2FCE4; color: #000; }

                .paylater-card h3 {
                    font-size: 1.25rem;
                    font-weight: 700;
                    color: #3E6D9C;
                    margin-bottom: 0.75rem;
                }

                .paylater-schedule {
                    display: flex;
                    gap: 0.5rem;
                    margin: 1rem 0;
                    flex-wrap: wrap;
                }
                .paylater-schedule div {
                    flex: 1 1 0;
                    min-width: 70px;
                    background: #f8f9fa;
                    border-radius: 10px;
                    padding: 0.6rem 0.4rem;
                    text-align: center;
                    font-size: 0.85rem;
                    color: #666;
                }
                .paylater-schedule strong { display: block; color: #1A1A1A; font-size: 0.95rem; }

                .paylater-steps {
                    counter-reset: step;
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
                .paylater-steps li {
                    counter-increment: step;
                    position: relative;
                    padding-left: 2.5rem;
                    margin-bottom: 1rem;
                    line-height: 1.6;
                    color: #444;
                }
                .paylater-steps li::before {
                    content: counter(step);
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 1.75rem;
                    height: 1.75rem;
                    border-radius: 50%;
                    background: #FD7014;
                    color: white;
                    font-weight: 700;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.9rem;
                }

                @media (max-width: 768px) {
                    .help-category-card {
                        padding: 1.5rem;
                    }

                    .help-icon {
                        font-size: 2rem;
                    }

                    .help-category-title {
                        font-size: 1.2rem;
                    }
                }
            `}</style>

            {/* Back Button */}
            <Container style={{marginTop: '2rem'}}>
                <Link className="btn btn-light orange-outline" to="/">
                    ← Go Back
                </Link>
            </Container>

            {/* Clean Header - No Gradient */}
            <Container style={{
                textAlign: 'center',
                marginTop: '3rem',
                marginBottom: '3rem'
            }}>
                <div style={{ fontSize: '5rem', marginBottom: '1rem' }}>
                    {/*💬 (speech bubble - for help/questions)*/}
                    {/*🆘 (SOS - for help)*/}
                    {/*❔ (white question mark)*/}
                    {/*🤔 (thinking face)*/}
                    {/*💡 (lightbulb - for solutions)*/}
                    💬
                </div>
                <h1 style={{
                    fontWeight: 'bold',
                    marginBottom: '1rem',
                    color: '#3E6D9C'
                }}>
                    How Can We Help You?
                </h1>
                <p style={{
                    color: '#666',
                    fontSize: '1.1rem',
                    maxWidth: '800px',
                    margin: '0 auto'
                }}>
                    Find answers to common questions and get support
                </p>
            </Container>

            <Container>
                {/* Quick Help Categories */}
                <Row className="mb-5">
                    <Col md={4}>
                        <div className="help-category-card">
                            <div className="help-icon"><FaTruck /></div>
                            <h3 className="help-category-title">Shipping & Delivery</h3>
                            <p className="help-category-description">
                                Free UK shipping on orders over £50. Standard delivery takes 3-5 business days.
                            </p>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="help-category-card">
                            <div className="help-icon"><FaUndo /></div>
                            <h3 className="help-category-title">Returns & Refunds</h3>
                            <p className="help-category-description">
                                14-day returns. Items must be unused and in original packaging.
                            </p>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div className="help-category-card">
                            <div className="help-icon"><FaShieldAlt /></div>
                            <h3 className="help-category-title">Secure Payment</h3>
                            <p className="help-category-description">
                                SSL encrypted checkout. We accept Visa, Mastercard, Amex, Apple Pay, Google Pay, PayPal, Klarna and Clearpay.
                            </p>
                        </div>
                    </Col>
                </Row>

                {/* Pay later — linked from the landing page's "How paying later works" */}
                <Row className="mb-5 paylater-section" id="pay-later">
                    <Col>
                        <h2 className="mb-2" style={{color: '#3E6D9C', fontWeight: '700'}}>
                            <FaCreditCard style={{marginRight: '0.5rem', color: '#FD7014'}} />
                            How Paying Later Works
                        </h2>
                        <p style={{color: '#666', marginBottom: 0}}>
                            Spread the cost of your order with Klarna or Clearpay — interest-free, with no extra cost from us.
                        </p>
                        <div style={{maxWidth: 520, marginBottom: '1.5rem'}}>
                            <PayLaterMessage price={60} />
                        </div>

                        <Row className="g-4 mb-4">
                            <Col md={6}>
                                <div className="paylater-card">
                                    <span className="paylater-badge paylater-badge--klarna">Klarna.</span>
                                    <h3>Pay in 3</h3>
                                    <p style={{color: '#666', marginBottom: 0}}>
                                        Split your order into 3 equal, interest-free payments. The first is taken when you order,
                                        then the rest every 30 days.
                                    </p>
                                    <div className="paylater-schedule" aria-label="Example: £60 order with Klarna">
                                        <div><strong>£20</strong>Today</div>
                                        <div><strong>£20</strong>In 30 days</div>
                                        <div><strong>£20</strong>In 60 days</div>
                                    </div>
                                    <small style={{color: '#888'}}>Example based on a £60 order. Available on pre-orders too.</small>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="paylater-card">
                                    <span className="paylater-badge paylater-badge--clearpay">clearpay</span>
                                    <h3>Pay in 4</h3>
                                    <p style={{color: '#666', marginBottom: 0}}>
                                        Split your order into 4 equal, interest-free payments. The first is taken when you order,
                                        then the rest every 2 weeks.
                                    </p>
                                    <div className="paylater-schedule" aria-label="Example: £60 order with Clearpay">
                                        <div><strong>£15</strong>Today</div>
                                        <div><strong>£15</strong>Week 2</div>
                                        <div><strong>£15</strong>Week 4</div>
                                        <div><strong>£15</strong>Week 6</div>
                                    </div>
                                    <small style={{color: '#888'}}>Example based on a £60 order. Not available on pre-orders.</small>
                                </div>
                            </Col>
                        </Row>

                        <Row className="g-4">
                            <Col lg={5}>
                                <h3 style={{fontSize: '1.2rem', fontWeight: 700, color: '#3E6D9C', marginBottom: '1rem'}}>Using it at checkout</h3>
                                <ol className="paylater-steps">
                                    <li>Add your items to your basket and go to <strong>Checkout</strong>.</li>
                                    <li>Under <strong>Payment</strong>, choose <strong>Klarna</strong> or <strong>Clearpay</strong>.</li>
                                    <li>You'll be taken to their secure page to sign in or sign up. They'll tell you straight away if you're approved.</li>
                                    <li>You'll come back to RetroDayz with your order confirmed. Klarna or Clearpay will remind you before each payment is due.</li>
                                </ol>
                            </Col>
                            <Col lg={7}>
                                <Accordion>
                                    <Accordion.Item eventKey="pl0">
                                        <Accordion.Header>Does it cost anything extra?</Accordion.Header>
                                        <Accordion.Body>
                                            No. You pay the same price as paying in full, with no interest. If you miss a payment, Klarna or
                                            Clearpay may charge a late fee — check their terms before you agree to a plan.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="pl1">
                                        <Accordion.Header>Will it affect my credit score?</Accordion.Header>
                                        <Accordion.Body>
                                            Klarna and Clearpay run their own checks when you apply, and may share information about your
                                            plan with credit reference agencies. Paying on time is the best way to keep things healthy.
                                            Their terms explain exactly what they check and report.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="pl2">
                                        <Accordion.Header>Why can't I see Klarna or Clearpay at checkout?</Accordion.Header>
                                        <Accordion.Body>
                                            They're offered for UK delivery addresses and depend on your order total — very small or very
                                            large orders may not qualify. Clearpay isn't available on pre-orders, as its terms don't allow
                                            them; Klarna is.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="pl3">
                                        <Accordion.Header>What happens if I return something?</Accordion.Header>
                                        <Accordion.Body>
                                            Once we've processed your return, the refund goes back to Klarna or Clearpay and is taken off
                                            your plan, so your remaining payments go down (or you're refunded what you've already paid).
                                            See the returns questions below for how to send items back.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="pl4">
                                        <Accordion.Header>Who do I contact about my payments?</Accordion.Header>
                                        <Accordion.Body>
                                            For your payment schedule, changing a due date or paying early, use the Klarna or Clearpay app or
                                            website — your agreement is with them. For anything about your order itself, <Link to="/contact">contact us</Link>.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                {/* FAQ Section */}
                <Row className="mb-5">
                    <Col>
                        <h2 className="mb-4" style={{color: '#3E6D9C', fontWeight: '700'}}>
                            <FaQuestionCircle style={{marginRight: '0.5rem', color: '#FD7014'}} />
                            Frequently Asked Questions
                        </h2>
                        <Accordion>
                            {/* Order & Payment FAQs */}
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>How do I track my order?</Accordion.Header>
                                <Accordion.Body>
                                    Once your order ships, you'll receive a tracking number via email. You can also view your order status by logging into your account and visiting the <Link to="/orders">Order History</Link> page.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="1">
                                <Accordion.Header>What payment methods do you accept?</Accordion.Header>
                                <Accordion.Body>
                                    We accept Visa, Mastercard, American Express and Maestro, plus Apple Pay, Google Pay and PayPal. You can also spread the cost with Klarna (pay in 3) or Clearpay (pay in 4), interest-free. All payments are processed securely by Stripe — we never see or store your card details.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="2">
                                <Accordion.Header>Can I change or cancel my order?</Accordion.Header>
                                <Accordion.Body>
                                    Orders can be modified or cancelled within 1 hour of placing them. After that, orders enter our fulfillment process. Please <Link to="/contact">contact us</Link> immediately if you need to make changes.
                                </Accordion.Body>
                            </Accordion.Item>

                            {/* Shipping FAQs */}
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>How long does delivery take?</Accordion.Header>
                                <Accordion.Body>
                                    <strong>UK Standard Delivery:</strong> 3-5 business days<br/>
                                    <strong>UK Express Delivery:</strong> 1-2 business days<br/>
                                    <strong>International Delivery:</strong> 7-14 business days<br/>
                                    Orders placed before 2pm are dispatched the same day (Mon-Fri).
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="4">
                                <Accordion.Header>Do you offer free shipping?</Accordion.Header>
                                <Accordion.Body>
                                    Yes! We offer free standard UK delivery on all orders over £50. Orders under £50 have a £3.99 delivery charge.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="5">
                                <Accordion.Header>Do you ship internationally?</Accordion.Header>
                                <Accordion.Body>
                                    Yes, we ship to most countries worldwide. International shipping costs are calculated at checkout based on your location and order weight.
                                </Accordion.Body>
                            </Accordion.Item>

                            {/* Returns FAQs */}
                            <Accordion.Item eventKey="6">
                                <Accordion.Header>What is your returns policy?</Accordion.Header>
                                <Accordion.Body>
                                    You can return items within 14 days of receiving them. Items must be returned unused, in original packaging with all tags attached. To start a return, <Link to="/contact">contact our support team</Link> with your order number.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="7">
                                <Accordion.Header>How do I return an item?</Accordion.Header>
                                <Accordion.Body>
                                    1. <Link to="/contact">Contact us</Link> within 14 days of receiving your order<br/>
                                    2. We'll provide a return authorization and instructions<br/>
                                    3. Pack items securely in original packaging<br/>
                                    4. Send via tracked delivery (we recommend keeping proof of postage)<br/>
                                    5. Refund processed within 5-7 days of receiving your return
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="8">
                                <Accordion.Header>Who pays for return shipping?</Accordion.Header>
                                <Accordion.Body>
                                    If returning due to a defect or our error, we'll cover return shipping costs. For standard returns (change of mind), customers are responsible for return postage.
                                </Accordion.Body>
                            </Accordion.Item>

                            {/* Product FAQs */}
                            <Accordion.Item eventKey="9">
                                <Accordion.Header>Are your products officially licensed?</Accordion.Header>
                                <Accordion.Body>
                                    Yes! All our branded merchandise is officially licensed. We work directly with copyright holders to ensure authenticity and quality.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="10">
                                <Accordion.Header>How do I care for my retro products?</Accordion.Header>
                                <Accordion.Body>
                                    <strong>T-Shirts:</strong> Machine wash cold, inside out. Tumble dry low or hang dry. Do not iron directly on print.<br/>
                                    <strong>Mugs:</strong> Hand wash recommended. Microwave safe but not dishwasher safe.<br/>
                                    <strong>Lighting:</strong> LED bulbs included. Keep away from water. Wipe with dry cloth only.<br/>
                                    <strong>Collectables:</strong> Keep in original packaging for best preservation. Display away from direct sunlight.
                                </Accordion.Body>
                            </Accordion.Item>

                            {/* Account FAQs */}
                            <Accordion.Item eventKey="11">
                                <Accordion.Header>Do I need an account to place an order?</Accordion.Header>
                                <Accordion.Body>
                                    No, you can checkout as a guest. However, creating an account lets you track orders, save addresses, and view order history for faster future purchases.
                                </Accordion.Body>
                            </Accordion.Item>

                            <Accordion.Item eventKey="12">
                                <Accordion.Header>I forgot my password. What should I do?</Accordion.Header>
                                <Accordion.Body>
                                    Click the <Link to="/passwordreset">"Forgot Password"</Link> link on the login page. Enter your email address and we'll send you instructions to reset your password.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>

                {/* Size Guide */}
                <Row className="mb-5">
                    <Col>
                        <h2 className="mb-4" style={{color: '#3E6D9C', fontWeight: '700'}}>
                            <FaRuler style={{marginRight: '0.5rem', color: '#FD7014'}} />
                            T-Shirt Size Guide
                        </h2>
                        <p style={{marginBottom: '1.5rem'}}>All measurements in inches. Measured flat across the chest.</p>
                        <div style={{overflowX: 'auto'}}>
                            <table className="size-chart-table table table-bordered">
                                <thead>
                                <tr>
                                    <th>Size</th>
                                    <th>Chest (inches)</th>
                                    <th>Length (inches)</th>
                                    <th>UK Size</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td><strong>Small</strong></td>
                                    <td>34-36</td>
                                    <td>27</td>
                                    <td>UK 8-10</td>
                                </tr>
                                <tr>
                                    <td><strong>Medium</strong></td>
                                    <td>38-40</td>
                                    <td>28</td>
                                    <td>UK 10-12</td>
                                </tr>
                                <tr>
                                    <td><strong>Large</strong></td>
                                    <td>42-44</td>
                                    <td>29</td>
                                    <td>UK 12-14</td>
                                </tr>
                                <tr>
                                    <td><strong>X-Large</strong></td>
                                    <td>46-48</td>
                                    <td>30</td>
                                    <td>UK 14-16</td>
                                </tr>
                                <tr>
                                    <td><strong>XX-Large</strong></td>
                                    <td>50-52</td>
                                    <td>31</td>
                                    <td>UK 16-18</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <p style={{fontSize: '0.9rem', color: '#666', marginTop: '1rem'}}>
                            <strong>Sizing Tip:</strong> Our t-shirts have a regular fit. If you prefer a looser fit, we recommend ordering one size up.
                        </p>
                    </Col>
                </Row>

                {/* Contact Information */}
                <Row className="mb-5">
                    <Col>
                        <h2 className="mb-4" style={{color: '#3E6D9C', fontWeight: '700'}}>
                            <FaEnvelope style={{marginRight: '0.5rem', color: '#FD7014'}} />
                            Still Need Help?
                        </h2>
                        <Row>
                            <Col md={6}>
                                <div className="contact-info-box">
                                    <h5><FaEnvelope /> Email Support</h5>
                                    <p style={{marginBottom: '0.5rem'}}>support@retrodayz.co.uk</p>
                                    <p style={{fontSize: '0.9rem', color: '#666', marginBottom: 0}}>
                                        We typically respond within 24 hours
                                    </p>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="contact-info-box">
                                    <h5><FaEnvelope /> Contact Form</h5>
                                    <p style={{marginBottom: 0}}>
                                        <Link to="/contact">Send us a message</Link> and we'll reply as soon as we can
                                    </p>
                                </div>
                            </Col>
                        </Row>
                        <div style={{textAlign: 'center', marginTop: '2rem'}}>
                            <Link
                                to="/contact"
                                className="btn btn-lg"
                                style={{
                                    background: '#FD7014',
                                    color: 'white',
                                    padding: '1rem 3rem',
                                    borderRadius: '50px',
                                    textDecoration: 'none',
                                    fontWeight: '600',
                                    border: 'none'
                                }}
                            >
                                Contact Support Team
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>

            <StayTop />
        </>
    );
};

export default HelpScreen;